import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { deleteRequest, postRequest } from '../services/apiMethods';

import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ConfirmModal = ({ isModalOpen, handleConfirmClose, data, selectedType, refetch }) => {
    const navigate = useNavigate(); // Correctly calling the hook

    const { mutate: deleteEmployee, isLoading: isDeletingEmployeeLoding } = useMutation({
        mutationFn: (data) => deleteRequest(`/employee/delete${data}`),
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            navigate("/my-profile?tab=sixth");
            handleConfirmClose();
        },
        onError: (error) => {
            console.error("Error during API call:", error)
        },
    });

    const { mutate: deletePortfolio, isLoading: isDeletingPortfolioLoding } = useMutation({
        mutationFn: (data) => deleteRequest(`/Portfolio/delete${data}`),
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            navigate("/my-profile?tab=fourth");
            handleConfirmClose();
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });

    const { mutate: deleteAccreditations, isLoading: isDeletingAccreditationsLoding } = useMutation({
        mutationFn: (data) => deleteRequest(`/accreditation/delete${data}`),
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            navigate("/my-profile?tab=fifth");
            handleConfirmClose();
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });



    const { mutate: deletevendorDelete, isLoading: deletevendorDeleteLoading } = useMutation({
        mutationFn: () => deleteRequest(`/profile/delete`),
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            handleConfirmClose();
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });


    const { mutate: deleteCustomer, isLoading: deleteCustomerLoading } = useMutation({
        mutationFn: () => deleteRequest(`/profile/delete`),
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            handleConfirmClose();
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });


    const { mutate: deleteCustomerEnquiry, isLoading: deleteCustomerEnquiryloading } = useMutation({
        mutationFn: () => deleteRequest(`lead/delete?leadId=${data}`),
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            handleConfirmClose();
            navigate("/customer-dashboard")
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });



    const { mutate: deleteService, isLoading: isDeletingServiceLoding } = useMutation({
        mutationFn: (data) => {
            const values = {
                service: data?.service,
                category: data?.category
            }
            postRequest(`/service/remove`, values)
        },
        onSuccess: (response) => {
            toast.success(`${response?.message}`, {
                iconTheme: {
                    primary: '#337FE0',
                    secondary: '#FFFAEE',
                },
            })
            handleConfirmClose();
            refetch()
            window.location.reload()
        },
        onError: (error) => {
            console.error("Error during API call:", error);
        },
    });


    const handleDeletePortfolio = () => {
        if (data) {
            deletePortfolio(data);
        } else {
            toast.error("Invalid data for deletion.");
        }
    };

    const handleDeleteEmployee = () => {
        if (data) {
            deleteEmployee(data);
        } else {
            toast.error("Invalid data for deletion.");
        }
    };

    const handleDeleteAccreditations = () => {
        if (data) {
            deleteAccreditations(data);
        } else {
            toast.error("Invalid data for deletion.");
        }
    };



    const handleVendorDelete = () => {
        deletevendorDelete();

    };

    const handleCustomerDelete = () => {
        deleteCustomer();

    };

    const handleDeleteCustomerEnquiry = () => {
        deleteCustomerEnquiry();

    };





    const handleDeletService = () => {
        if (data) {
            deleteService(data);
        } else {
            toast.error("Invalid data for deletion.");
        }
    };

    return (
        <Modal
            show={isModalOpen}
            onHide={handleConfirmClose}
            className="comn-modal-set"
        >


            {selectedType === "serviceDelete" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body className='p-0'>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to remove this service ?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}



            {selectedType === "deleteCustomerEnquiry" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body className='p-0'>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to delete this enquiry ?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}


            {selectedType === "portfolio" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body className='p-0'>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to delete?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}

            {selectedType === "vendorDelete" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body className='p-0'>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to delete?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}

            {selectedType === "customerDelete" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body className='p-0'>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to delete?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}


            {selectedType === "employee" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to delete?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}
            {selectedType === "accreditations" && (
                <>
                    <Modal.Header className="border-none" closeButton>
                    </Modal.Header>

                    <Modal.Body>
                        <div className='commn-pop-content'>
                            <h2>Delete</h2>
                            <p className="text-center suspend-text">
                                Are you sure you want to delete?
                            </p>
                        </div>
                    </Modal.Body>
                </>
            )}
            <Modal.Footer className="border-none justify-content-center modal-footer mb-4">



                {selectedType === "serviceDelete" && (
                    <button
                        onClick={handleDeletService}

                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}
                {selectedType === "portfolio" && (
                    <button
                        onClick={handleDeletePortfolio}

                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}
                {selectedType === "employee" && (
                    <button
                        onClick={handleDeleteEmployee}

                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}
                {selectedType === "accreditations" && (
                    <button
                        onClick={handleDeleteAccreditations}
                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}

                {selectedType === "deleteCustomerEnquiry" && (
                    <button
                        onClick={handleDeleteCustomerEnquiry}
                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}

                {selectedType === "vendorDelete" && (
                    <button
                        onClick={handleVendorDelete}
                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}

                {selectedType === "customerDelete" && (
                    <button
                        onClick={handleCustomerDelete}
                        className="theme-comm-btn"
                    >
                        Yes
                    </button>
                )}


                <button
                    onClick={handleConfirmClose}
                    className="theme-red-comm-btn"
                >
                    No
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmModal;
